export { userWordTable, type UserWord } from "#user-word-table";
